import Page from 'flarum/common/components/Page';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import app from 'flarum/forum/app';

const FAQ = [
  {
    q: 'What is Wealth Warrior Awakenings 101?',
    a: 'A daily practice course of nine awakenings (modules). Instead of just reading, you integrate each lesson in your own words and record the actions you take — turning ideas into upgrades to how you actually live.',
  },
  {
    q: 'How do I sign up?',
    a: 'Tap "Begin the Path" on the home page and create your account. Enrollment is automatic — the moment you register you are enrolled in the course. There is no separate sign-up step and it is free to begin.',
  },
  {
    q: 'Do I have to confirm my email?',
    a: 'Yes. Right after you register we send a confirmation link to your email. You must confirm it before the course content unlocks. If it does not arrive within a few minutes, check your spam folder or use the "Resend confirmation email" button in the banner at the top of the site.',
  },
  {
    q: 'What does it take to complete a module?',
    a: 'Work one module at a time, in order. To complete a module you post an "integration" of at least 500 characters — your own words on what the lesson means and how you are putting it to use. You may also add the actions you took as a result.',
  },
  {
    q: 'What is the difference between an integration and actions?',
    a: 'Your integration is where you teach the lesson back to yourself in writing (minimum 500 characters, required). Actions are the concrete, past-tense things you did because of it — "I scheduled…", "I set up…", "I removed…". Actions are optional, but they are where the real change happens.',
  },
  {
    q: 'When does the next module open?',
    a: 'Module 1 is available as soon as you enroll and confirm your email. Each time you post your integration, the next module opens at the next 8:00 AM Eastern Time. One module per day — by design, so it stays a discipline rather than a binge.',
  },
  {
    q: 'Can I skip ahead or move faster?',
    a: 'No. Modules unlock one per day, in sequence. You advance when the integration is real — not when the reading is done. A locked module shows the date and time it becomes available.',
  },
  {
    q: 'What email will I receive?',
    a: 'After you post your first integration on a module, we email you a copy for your records. It includes a note from Skye, your integration, your actions, and a link to the next module with the date and time it becomes available. After module 9 you receive a completion message.',
  },
  {
    q: 'Where do I find my course and modules?',
    a: 'Once you are logged in you land on "Your Courses." Open the course to see every module. Completed and available modules open directly; locked ones show when they will unlock.',
  },
];

export default class WwaFaqPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('FAQ — Wealth Warrior Awakenings 101');
    app.setTitleCount(0);
  }

  view() {
    const isLoggedIn = !!(app.session && app.session.user);

    return (
      <div className="WwaFaqPage">
        <div className="container">
          <header className="WwaFaq-head">
            <h1 className="WwaFaq-title">Frequently Asked Questions</h1>
            <p className="WwaFaq-intro">
              Everything you need to know about enrolling, the integration dojo, and how you progress through the path.
            </p>
          </header>

          <div className="WwaFaq-list">
            {FAQ.map((item) => (
              <section className="WwaFaq-item">
                <h3 className="WwaFaq-q">{item.q}</h3>
                <p className="WwaFaq-a">{item.a}</p>
              </section>
            ))}
          </div>

          <div className="WwaFaq-cta">
            {!isLoggedIn && (
              <button className="Button Wwa-cta Wwa-cta--large" onclick={() => this.handleSignUp()}>
                Begin the Path
              </button>
            )}
            {isLoggedIn && (
              <a href={app.route('courses')} className="Button Wwa-cta Wwa-cta--large">
                Enter the Dojo
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }

  handleSignUp() {
    app.modal.show(SignUpModal, { courseEnrollmentKey: 'course-wwa-101' });
  }
}
